import { ConfigProvider, Flex, Progress, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useAntTheme } from "hooks/useAntTheme";

export const LoadingProgress = ({ message, progress }) => {
  const { theme } = useAntTheme();

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      style={{
        width: "100%",
        maxWidth: "800px",
      }}
      gap={32}
    >
      <LoadingOutlined
        style={{
          fontSize: 128,
          color: theme.colorPrimary,
        }}
        spin
      />
      <Typography.Text
        style={{
          fontSize: 40,
        }}
      >
        {message}
      </Typography.Text>
      <ConfigProvider
        theme={{
          token: {
            colorSuccess: theme.colorPrimary,
          },
          components: {
            Progress: {
              fontSize: 40,
              marginXS: 20,
            },
          },
        }}
      >
        <Progress
          percent={progress}
          trailColor={"#d9d9d9"}
          strokeColor={theme.colorPrimary}
          strokeWidth={16}
          style={{ width: "100%" }}
          format={(percent) => `${percent}%`}
        />
      </ConfigProvider>
    </Flex>
  );
};
